var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { st, classes } from './ColorPickerItem.st.css';
import { RadioButton } from 'wix-ui-core/dist/es/src/components/radio-button';
import { TPAComponentsContext } from '../../TPAComponentsConfig';
import { TOOLTIP_COMMON_PROPS } from './tooltipCommonProps';
import { MobileTooltip } from './MobileTooltip';
import { Tooltip } from '../../Tooltip';
import { colorPickerItemDataHook, colorPickerItemDataCrossed, colorPickerItemCheckedDateHook, colorPickerItemTooltipDataHook, } from '../dataHooks';
var ColorPickerItem = /** @class */ (function (_super) {
    __extends(ColorPickerItem, _super);
    function ColorPickerItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { focused: false, focusedByKeyboard: false };
        _this._onHover = function () {
            _this.setState({ focused: true });
        };
        _this._onIconBlur = function () {
            _this.setState({ focused: false });
        };
        _this._onFocusByKeyboard = function () {
            _this.setState({ focusedByKeyboard: true });
        };
        _this._onBlur = function () {
            _this.setState({ focusedByKeyboard: false });
        };
        _this._getColorDotContent = function () {
            var value = _this.props.value;
            return (React.createElement("div", { className: classes.radioOuter },
                React.createElement("div", { className: classes.radioInner, style: { backgroundColor: value } })));
        };
        return _this;
    }
    ColorPickerItem.prototype._getTooltipProps = function () {
        var _a;
        var mobile = this.context.mobile;
        var _b = this.props, tooltip = _b.tooltip, tooltipDataHook = _b.tooltipDataHook;
        return mobile
            ? { tooltip: tooltip }
            : __assign((_a = { content: tooltip }, _a['data-hook'] = tooltipDataHook, _a), TOOLTIP_COMMON_PROPS);
    };
    ColorPickerItem.prototype._getColorDot = function () {
        var mobile = this.context.mobile;
        var tooltip = this.props.tooltip;
        var colorDot = this._getColorDotContent();
        if (tooltip) {
            var TooltipType = (mobile ? MobileTooltip : Tooltip);
            var tooltipProps = this._getTooltipProps();
            colorDot = React.createElement(TooltipType, __assign({}, tooltipProps), colorDot);
        }
        return colorDot;
    };
    ColorPickerItem.prototype.render = function () {
        var _a;
        var mobile = this.context.mobile;
        var _b = this.state, focused = _b.focused, focusedByKeyboard = _b.focusedByKeyboard;
        var _c = this.props, className = _c.className, checked = _c.checked, ariaLabel = _c["aria-label"], tooltipDataHook = _c.tooltipDataHook, disabled = _c.disabled, value = _c.value, onChange = _c.onChange, name = _c.name, isCrossedOut = _c.isCrossedOut;
        var colorDot = this._getColorDot();
        return (React.createElement(RadioButton, __assign({ className: st(classes.root, {
                checked: checked,
                focused: focused,
                focusedByKeyboard: focusedByKeyboard,
                unavailable: isCrossedOut,
            }, className) }, (_a = {},
            _a[colorPickerItemDataCrossed] = isCrossedOut,
            _a[colorPickerItemCheckedDateHook] = checked && !disabled,
            _a), { "aria-label": ariaLabel, "data-hook": colorPickerItemDataHook, "data-tooltip-hook": tooltipDataHook, disabled: disabled, checked: checked && !disabled, checkedIcon: colorDot, value: value, uncheckedIcon: colorDot, onChange: onChange, name: name, onHover: mobile ? undefined : this._onHover, onIconBlur: mobile ? undefined : this._onIconBlur, onFocusByKeyboard: !mobile ? this._onFocusByKeyboard : undefined, onBlur: !mobile ? this._onBlur : undefined })));
    };
    ColorPickerItem.displayName = 'ColorPickerItem';
    ColorPickerItem.defaultProps = {
        tooltipDataHook: colorPickerItemTooltipDataHook,
    };
    ColorPickerItem.contextType = TPAComponentsContext;
    return ColorPickerItem;
}(React.Component));
export { ColorPickerItem };
//# sourceMappingURL=ColorPickerItem.js.map